(function () {
  function setupEDD(eddRoot) {
    if (!eddRoot || eddRoot.dataset.eddReady === 'true') return;
    eddRoot.dataset.eddReady = 'true';

    var inlineForm = eddRoot.querySelector('[data-edd-inline-form]');
    var inlineInput = eddRoot.querySelector('[data-edd-inline-input]');
    var inlineError = eddRoot.querySelector('[data-edd-inline-error]');
    var resultWrap = eddRoot.querySelector('[data-edd-result]');
    var resultLine = eddRoot.querySelector('[data-edd-result-line]');
    var resultSubline = eddRoot.querySelector('[data-edd-result-subline]');
    var updateBtnClass = 'hdt-edd__update-btn';
    var inlineCheckWrap = inlineForm ? inlineForm.parentNode : null;
    var sectionId = eddRoot.getAttribute('data-section-id') || '';
    var productId = eddRoot.getAttribute('data-product-id') || '';
    var storageKey = 'pdp_edd_state_' + sectionId + '_' + productId;
    var modalBound = false;

    function getModal() {
      return document.getElementById('hdt-edd-modal-global');
    }

    function getPopupForm() {
      var modal = getModal();
      return modal ? modal.querySelector('[data-edd-popup-form]') : null;
    }

    function getPopupInput() {
      var modal = getModal();
      return modal ? modal.querySelector('[data-edd-popup-input]') : null;
    }

    function getPopupError() {
      var modal = getModal();
      return modal ? modal.querySelector('[data-edd-popup-error]') : null;
    }

    function digitsOnly(value) {
      return String(value || '').replace(/\D/g, '').slice(0, 6);
    }

    function isValidPincode(pin) {
      return /^[1-9][0-9]{5}$/.test(pin);
    }

    function findCityForPincode(pin) {
      var modal = getModal();
      if (!modal) return '';
      var match = modal.querySelector('[data-edd-address-pincode="' + pin + '"]');
      return match ? (match.getAttribute('data-edd-address-city') || '').trim() : '';
    }

    function formatLocationLabel(pincode, city) {
      var cityLabel = String(city || '').trim() || findCityForPincode(pincode);
      if (cityLabel) return pincode + ' (' + cityLabel + ')';
      return pincode;
    }

    function setCheckButtonsLoading(loading) {
      if (inlineForm) {
        var inlineBtn = inlineForm.querySelector('.hdt-edd__check-btn');
        if (inlineBtn) inlineBtn.disabled = loading;
      }
      var popupForm = getPopupForm();
      if (popupForm) {
        var popupBtn = popupForm.querySelector('.hdt-edd__check-btn');
        if (popupBtn) popupBtn.disabled = loading;
      }
    }

    function formatDeliveryDate(rawDate) {
      if (!rawDate) return '';
      if (typeof rawDate === 'string' && rawDate.trim()) {
        var parsedDate = new Date(rawDate);
        if (!isNaN(parsedDate.getTime())) {
          return parsedDate.toLocaleDateString('en-IN', { weekday: 'long', day: 'numeric', month: 'long' });
        }
        return rawDate.trim();
      }
      return '';
    }

    function extractDeliveryDate(payload) {
      if (!payload || typeof payload !== 'object') return '';
      var data = payload.data && typeof payload.data === 'object' ? payload.data : payload;
      if (data.estimated_date) {
        return formatDeliveryDate(data.estimated_date);
      }
      if (data.recommendedCourier && data.recommendedCourier.etd) {
        return formatDeliveryDate(data.recommendedCourier.etd);
      }
      return '';
    }

    function extractApiErrorMessage(payload) {
      if (!payload || typeof payload !== 'object') {
        return 'Sorry! Delivery is unavailable at this pincode.';
      }
      if (typeof payload.message === 'string' && payload.message.trim()) {
        return payload.message.trim();
      }
      if (payload.data && typeof payload.data.message === 'string' && payload.data.message.trim()) {
        return payload.data.message.trim();
      }
      return 'Sorry! Delivery is unavailable at this pincode.';
    }

    async function checkDeliveryFromApi(pin) {
      var endpoint = 'https://api.aqualogica.in/v1/order/estimate-delivery-date/' + pin;
      var response = await fetch(endpoint, {
        method: 'GET',
        headers: {
          Accept: 'application/json'
        }
      });

      var payload = null;
      try {
        payload = await response.json();
      } catch (err) {}

      var apiStatus = payload && typeof payload.status === 'string'
        ? payload.status.toLowerCase()
        : '';
      var isSuccess = response.ok && apiStatus === 'ok';
      var deliveryLabel = isSuccess ? extractDeliveryDate(payload) : '';

      if (isSuccess && !deliveryLabel) {
        isSuccess = false;
      }

      return {
        status: isSuccess ? 'success' : 'error',
        pincode: pin,
        deliveryLabel: deliveryLabel,
        errorMessage: isSuccess ? '' : extractApiErrorMessage(payload)
      };
    }

    function clearPopupInput() {
      var popupInput = getPopupInput();
      if (popupInput) {
        popupInput.value = '';
      }
      hidePopupError();
    }

    function setSelectedAddress(addressEl) {
      var modal = getModal();
      if (!modal) return;
      modal.querySelectorAll('.hdt-edd-modal__saved').forEach(function (item) {
        item.classList.remove('is-selected');
        var radio = item.querySelector('.hdt-edd-modal__saved-radio');
        if (radio) radio.checked = false;
      });
      if (!addressEl) return;
      addressEl.classList.add('is-selected');
      var selectedRadio = addressEl.querySelector('.hdt-edd-modal__saved-radio');
      if (selectedRadio) selectedRadio.checked = true;
    }

    function openModal() {
      var modal = getModal();
      if (!modal) return;
      bindModalEvents();
      clearPopupInput();

      var currentPincode = '';
      try {
        var savedState = window.localStorage.getItem(storageKey);
        if (savedState) {
          var parsedState = JSON.parse(savedState);
          currentPincode = digitsOnly(parsedState && parsedState.pincode);
        }
      } catch (err) {}

      if (currentPincode) {
        var matchedAddress = modal.querySelector('[data-edd-address-pincode="' + currentPincode + '"]');
        setSelectedAddress(matchedAddress || null);
      }

      modal.classList.add('is-open');
      document.body.style.overflow = 'hidden';
      var popupInput = getPopupInput();
      if (popupInput) {
        popupInput.focus();
      }
    }

    function closeModal() {
      var modal = getModal();
      if (!modal) return;
      modal.classList.remove('is-open');
      document.body.style.overflow = '';
    }

    function hideInlineError() {
      if (!inlineError) return;
      inlineError.textContent = '';
      inlineError.classList.add('hdt-edd__hidden');
    }

    function showInlineError(message) {
      if (!inlineError) return;
      inlineError.textContent = message;
      inlineError.classList.remove('hdt-edd__hidden');
    }

    function hidePopupError() {
      var popupError = getPopupError();
      if (!popupError) return;
      popupError.textContent = '';
      popupError.classList.add('hdt-edd__hidden');
    }

    function showPopupError(message) {
      var popupError = getPopupError();
      if (!popupError) return;
      popupError.textContent = message;
      popupError.classList.remove('hdt-edd__hidden');
    }

    function showInlineForm() {
      if (inlineForm) inlineForm.classList.remove('hdt-edd__hidden');
      if (resultWrap) resultWrap.classList.add('hdt-edd__hidden');
    }

    function updateResult(state) {
      if (!resultWrap || !resultLine || !resultSubline || !inlineCheckWrap) return;
      hideInlineError();
      hidePopupError();
      resultWrap.classList.remove('hdt-edd__hidden');
      inlineForm.classList.add('hdt-edd__hidden');
      resultWrap.classList.toggle('hdt-edd__result--error', state.status === 'error');

      var locationLabel = formatLocationLabel(state.pincode, state.city);

      if (state.status === 'success') {
        resultLine.innerHTML = 'Delivery by <strong>' + state.deliveryLabel + '</strong>';
        resultSubline.innerHTML = locationLabel + ' <button type="button" class="' + updateBtnClass + '" data-edd-update>Update location</button>';
      } else {
        var errorCopy = state.errorMessage || 'Sorry! Delivery is unavailable at this pincode.';
        resultLine.innerHTML = '<strong>' + errorCopy + '</strong>';
        resultSubline.innerHTML = '<button type="button" class="' + updateBtnClass + '" data-edd-update>Update location</button>';
      }

      try {
        window.localStorage.setItem(storageKey, JSON.stringify(state));
      } catch (err) {}
    }

    async function submitPincode(pin, source, city) {
      var normalizedPin = digitsOnly(pin);
      var cityLabel = String(city || '').trim();

      if (!isValidPincode(normalizedPin)) {
        if (source === 'popup') {
          showPopupError('Please enter a valid 6-digit pincode.');
        } else {
          showInlineError('Please enter a valid 6-digit pincode.');
        }
        return;
      }

      hideInlineError();
      hidePopupError();
      setCheckButtonsLoading(true);

      try {
        var nextState = await checkDeliveryFromApi(normalizedPin);
        nextState.city = cityLabel || findCityForPincode(normalizedPin);
        updateResult(nextState);
        closeModal();
      } catch (error) {
        if (source === 'popup') {
          showPopupError('Unable to check pincode right now. Please try again.');
        } else {
          showInlineError('Unable to check pincode right now. Please try again.');
        }
      } finally {
        setCheckButtonsLoading(false);
      }
    }

    function bindModalEvents() {
      var modal = getModal();
      if (!modal || modalBound) return;
      modalBound = true;

      var popupForm = getPopupForm();
      var popupInput = getPopupInput();

      if (popupInput) {
        popupInput.addEventListener('input', function () {
          popupInput.value = digitsOnly(popupInput.value);
          hidePopupError();
          setSelectedAddress(null);
        });
      }

      if (popupForm) {
        popupForm.addEventListener('submit', async function (event) {
          event.preventDefault();
          await submitPincode(popupInput ? popupInput.value : '', 'popup');
        });
      }

      modal.querySelectorAll('[data-edd-address-pincode]').forEach(function (addressEl) {
        addressEl.addEventListener('click', async function (event) {
          event.preventDefault();
          setSelectedAddress(addressEl);
          await submitPincode(
            addressEl.getAttribute('data-edd-address-pincode'),
            'popup',
            addressEl.getAttribute('data-edd-address-city') || ''
          );
        });
      });

      modal.querySelectorAll('[data-edd-modal-close]').forEach(function (button) {
        button.addEventListener('click', closeModal);
      });

      modal.addEventListener('click', function (event) {
        if (event.target && event.target.hasAttribute('data-edd-modal-close')) {
          closeModal();
        }
      });
    }

    if (inlineInput) {
      inlineInput.addEventListener('input', function () {
        inlineInput.value = digitsOnly(inlineInput.value);
        hideInlineError();
      });
    }

    if (inlineForm) {
      inlineForm.addEventListener('submit', async function (event) {
        event.preventDefault();
        await submitPincode(inlineInput ? inlineInput.value : '', 'inline');
      });
    }

    eddRoot.addEventListener('click', function (event) {
      var updateBtn = event.target.closest('[data-edd-update]');
      if (updateBtn) {
        event.preventDefault();
        openModal();
      }
    });

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', bindModalEvents);
    } else {
      bindModalEvents();
    }

    var defaultPincode = digitsOnly(eddRoot.getAttribute('data-default-pincode') || '');
    var isLoggedIn = eddRoot.getAttribute('data-customer-logged-in') === 'true';
    var hasSavedState = false;

    try {
      var savedState = window.localStorage.getItem(storageKey);
      if (savedState) {
        var parsedState = JSON.parse(savedState);
        if (parsedState && parsedState.pincode && parsedState.status) {
          updateResult(parsedState);
          hasSavedState = true;
        }
      }
    } catch (err) {}

    if (!hasSavedState && isLoggedIn && isValidPincode(defaultPincode)) {
      submitPincode(defaultPincode, 'inline', findCityForPincode(defaultPincode));
    } else if (!hasSavedState) {
      showInlineForm();
    }
  }

  function initPdpEdd() {
    document.querySelectorAll('[data-edd-root]').forEach(setupEDD);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initPdpEdd);
  } else {
    initPdpEdd();
  }

  document.addEventListener('shopify:section:load', initPdpEdd);
})();
